import React, { useState } from "react";
import "./EnquiryModal.css";

function EnquiryModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) =>
          encodeURIComponent(key) +
          "=" +
          encodeURIComponent(data[key])
      )
      .join("&");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("/", {
      method: "POST",
      headers: {
        "Content-Type":
          "application/x-www-form-urlencoded",
      },
      body: encode({
        "form-name": "enquiry",
        ...formData,
      }),
    })
      .then(() => {
        setStatus("success");

        setFormData({
          name: "",
          email: "",
          mobile: "",
          message: "",
        });
      })
      .catch(() => {
        setStatus("error");
      });
  };

  return (
    <div className="modal-overlay">
      <div className="enquiry-modal">

        {/* Close Button */}
        <button
          className="close-btn"
          onClick={onClose}
        >
          ×
        </button>

        <h2>Request a Consultation</h2>

        <p className="modal-subtitle">
          We'd love to discuss your lighting
          requirements and help bring your
          vision to life.
        </p>

        {/* Hidden Netlify Form */}
        <form
          name="enquiry"
          method="POST"
          data-netlify="true"
          onSubmit={handleSubmit}
        >
          <input
            type="hidden"
            name="form-name"
            value="enquiry"
          />

          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
          >
            Submit Enquiry
          </button>

          {status === "success" && (
            <p className="success-message">
              Thank you! We'll contact you
              shortly.
            </p>
          )}

          {status === "error" && (
            <p className="error-message">
              Something went wrong. Please
              try again.
            </p>
          )}
        </form>

        <div className="company-info">
          <h4>
            Kashi Lighting Design and
            Consultancy
          </h4>

          <p>
            📍 Nesco, WeWork,
            <br />
            Goregaon East,
            <br />
            Mumbai
          </p>

          <p>
            📞 +91 98697 95151
          </p>

          <p>
            ✉️ info@kashilighting.com
          </p>
        </div>

      </div>
    </div>
  );
}

export default EnquiryModal;